(() => {
  if (window.fpCalmNavigationReady) return;
  window.fpCalmNavigationReady = true;
  const initialize = (root = document) => {
    root.querySelectorAll('[data-fp-calm-nav]').forEach(nav => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const groups = [...nav.querySelectorAll('details')];
      const close = group => {
        group.open = false;
        group.querySelector('summary').setAttribute('aria-expanded', 'false');
      };
      groups.forEach(group => {
        const summary = group.querySelector('summary');
        let hoverOpened = false;
        summary.addEventListener('click', event => {
          if (event.detail > 0 && hoverOpened && group.open) event.preventDefault();
          hoverOpened = false;
        });
        group.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(group.open));
          if (group.open) groups.filter(other => other !== group).forEach(close);
        });
        group.addEventListener('keydown', event => {
          if (event.key === 'Escape' && group.open) {
            event.preventDefault();
            event.stopPropagation();
            close(group);
            summary.focus();
          }
        });
        group.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' && nav.id === 'fp-calm-header' && !group.open) {
            hoverOpened = true;
            group.open = true;
          }
        });
        group.addEventListener('pointerleave', event => {
          hoverOpened = false;
          if (event.pointerType === 'mouse' && nav.id === 'fp-calm-header' && !group.contains(document.activeElement)) close(group);
        });
        group.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (nav.id === 'fp-calm-header' && !group.contains(document.activeElement)) close(group);
          });
        });
      });
      document.addEventListener('click', event => {
        if (!nav.contains(event.target)) groups.forEach(close);
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
